import { Observable } from 'rxjs';
import { split, ref, getValues } from '@dbk-legacy/muster/utils';
import muster from '@dbk-legacy/muster';
import { sortable, variable } from '@dbk-legacy/muster/helpers';
import map from 'lodash/fp/map';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';

const getAssetIndex = path => split(path)[3];

export default () =>
  muster()

    .match('roster.portfolio.*', (requests, { watchValues }) =>
      watchValues('app.user.selectedPortfolioId')
        .map(([portfolioId]) =>
        requests.map(({ req, res }) => {
          // set('portfolio.busymode',true);
          return res.redirect(`roster.data.portfoliosById["${portfolioId}"].${req.params['*']}`);
        }
      ))
    )

    .path('portfolio.getData', {
      call: async ({ req }, { get, set, call }) => {
        console.log('portfolio.getData');
        // call('portfolio.clearData');
        const portfolioId = await getValues(get('app.user.selectedPortfolioId'));

        let ran_str = "random" + Math.round(Math.random() * 100);
       
        
        const [oPortfolioData]= await getValues(get(`roster.data.portfoliosById["${portfolioId}"].getPortfoliosData`));
        //  `portfolio.portfoliosYTDData`
        
         const portfolioData = JSON.parse(oPortfolioData);
        //  const portfoliosYTDData1=JSON.parse(portfoliosYTDData);
        
        const assetList = portfolioData.assetList;
        const assetNames = portfolioData.assetNames;
        const currencyExposure = portfolioData.currencyExposure;
        const marketValuesData = portfolioData.marketVal;
        const marketValuesLength = portfolioData.marketValueLength;
        const overallMarketValueAsOfDate = portfolioData.overallMarketValueAsOfDate;
        const overallMarketValueDayChangePercent = portfolioData.overallMarketValueDayChangePercent;
        const overallMarketValueDayChange = portfolioData.overallMarketValueDayChangeVal;
        const overallMarketValueNetIncome = portfolioData.overallMarketValueNetIncome;
        const overallMarketValuePrice = portfolioData.overallMarketValuePrice;
        const performanceChart = portfolioData.performanceChart;
        const performanceLineChart = portfolioData.performanceLineChart;

        await set('portfolio.overallMarketValue.value', overallMarketValuePrice);
        await set('portfolio.overallMarketValue.asOfDate', overallMarketValueAsOfDate);
        await set('portfolio.overallMarketValue.portfolioTransEndDate', overallMarketValueAsOfDate);
        await set('portfolio.dayChange.value', overallMarketValueDayChange);
        await set('portfolio.dayChange.percent', overallMarketValueDayChangePercent);
        await set('portfolio.netIncome.value', overallMarketValueNetIncome);
        await set('portfolio.marketValues.length', marketValuesLength);
        await set('portfolio.currencyExposure', currencyExposure);
        await set('portfolio.assetNames', assetNames);
        await set('portfolio.marketValuesData', marketValuesData);
        await set('portfolio.performanceChartData', performanceChart);
        await set('portfolio.performanceLineChartData', performanceLineChart);
        await set('portfolio.assetlist', assetList);
        await set('maturities.selectedTabIndex', 0);
        await set('portfolio.busymode', false);
        await call('auth.checkIsPaymentAvailable');
        // await call('auth.enablePaymentByPortfolioId'); /* WMCE-4427 Adding payment check in dashboard summary page */
      },
    })


    .path('portfolio.getmyassetlist', {
      call: async ({ req }, { get, set }) => {
        console.log("getmyassetlist");
        // call('portfolio.clearData');
        const portfolioId =  await getValues(get('app.user.selectedPortfolioId'));
        const [ 
          assetList,
          assetNames
        ] = await getValues(get([
          `roster.data.portfolio.getAssetList["${portfolioId}"]["emptyparentasset"]`,
          `roster.data.portfoliosById["${portfolioId}"].assetNames`,
        ]));
        await set('portfolio.assetlist', JSON.parse(assetList));
        await set('portfolio.assetNames', JSON.parse(assetNames));
      },
    })

    .path('portfolio.getOverallMarketAsOfDate', {
      call: async ({ req }, { get, set }) => {
        const portfolioId =  await getValues(get('app.user.selectedPortfolioId'));
        const guidStr = Guid();
        const [result] = await getValues(get([
          `roster.data.portfolio.getOverallMarketValue["${portfolioId}"]["${guidStr}"]`,
        ]));
        isValidJsonString(result).then(async (data) => {
          await set('portfolio.overallMarketValue.asOfDate', data.asOfDate);
        }).catch(async (error) => {
          console.log("error", error)
        });
      },
    })

    .path('portfolio.clearData', {
      call: async ({ req }, { get, set }) => {
        console.log("portfolio.getData");
        await set('portfolio.busymode',true);
        await set('portfolio.overallMarketValue.value', "");
        // await set('portfolio.overallMarketValue.asOfDate', "");  // Commented out to fix WMCE-7612
        await set('portfolio.dayChange.value', "");
        await set('portfolio.dayChange.percent',"" );
        await set('portfolio.netIncome.value', "");
        await set('portfolio.marketValues.length', 0);
        await set('portfolio.currencyExposure', "");
        await set('portfolio.assetNames', null);
        
        await set('portfolio.assetlist', []);
        await set('portfolio.marketValuesData',[]);
        await set('portfolio.performanceChartData', null);
        await set('portfolio.performanceLineChartData', null);
      },
    })

    .path(
      'portfolio.id',
      ({ res }) => res.redirect('app.user.selectedPortfolioId')
    )
    .path('portfolio.referenceCurrency',
      ({ res }) => res.redirect('app.user.selectedPortfolio.destinationCurrency')
    )
    // .path('portfolio.overallMarketValue.value',
    //   ref('roster.portfolio.overallMarketValue.price.value'))
    // .path('portfolio.overallMarketValue.asOfDate',
    //   ref('roster.portfolio.overallMarketValue.asOfDate.value'))
    // .path('portfolio.dayChange.value',
    //   ref('roster.portfolio.overallMarketValue.dayChange.value'))
    // .path('portfolio.dayChange.percent',
    //   ref('roster.portfolio.overallMarketValue.dayChange.percent'))
    // .path('portfolio.netIncome.value',
    //   ref('roster.portfolio.overallMarketValue.netIncome.value'))

    .path('portfolio.overallMarketValue.value', variable(0))
    .path('portfolio.overallMarketValue.asOfDate',variable(0))
    .path('portfolio.setTransactionEndDate',variable(0))
    .path('portfolio.dayChange.value',variable(0))
    .path('portfolio.dayChange.percent',variable(0))
    .path('portfolio.netIncome.value',variable(0))

    .path('portfolio.marketValuesData',variable([]))
    .path('portfolio.performanceChartData',variable([]))
    .path('portfolio.performanceLineChartData',variable([]))
    .path('portfolio.assetlist',variable([]))
    .path('portfolio.overallMarketValue.portfolioTransStartDate',variable(0))
    .path('portfolio.overallMarketValue.portfolioTransEndDate',variable(0))

    .path('portfolio.netIncome.onPress', {
      call: async ({ req }, { get, set }) => {
        const [messages] = await getValues(get('i18n.messages'));
        alert(messages['app.common.title.newIncome'], messages['app.common.title.clickIncome'], [
          { text: messages['app.rmcallback.okMsg']},
        ]);
      }
    })

    // .path('portfolio.marketValues.length', ref('roster.portfolio.marketValues.length'))
    .path('portfolio.marketValues.length', variable(0))
   
    .match('portfolio.marketValues[{integers:marketValueIndex}][{keys:key}]',
      (requests, { get }) =>
        get(requests.map(({ req }) =>
          `roster.portfolio.marketValues[${[req.params.marketValueIndex]}].${req.params.key}`))
          .map(pathValues =>
            pathValues.map(({ path, value }) => {
              const pathArray = split(path);
              return {
                path: `portfolio.marketValues[${pathArray[3]}].${pathArray[4]}`,
                value,
              };
            }))
    )
    .match('portfolio.marketValues[{integers:marketValueIndex}][{keys:key}][{keys:subKey}]',
      (requests, { get }) =>
        get(requests.map(({ req }) => {
          const {
            params: {
              marketValueIndex,
              key,
              subKey,
            },
          } = req;
          return `roster.portfolio.marketValues[${marketValueIndex}].${key}.${subKey}`;
        }))
          .map(pathValues =>
            pathValues.map(({ path, value }) => {
              const pathArray = split(path);
              return {
                path: `portfolio.marketValues[${pathArray[3]}].${pathArray[4]}.${pathArray[5]}`,
                value,
              };
            }))
    )
    .match('portfolio.assetsSorted[{integers:index}].*', sortable({
      fromList: 'portfolio.assets',
      toList: 'portfolio.assetsSorted',
      listLength: ref('portfolio.assets.length'),
      isAscending: ref('ui.state.portfolio.ascending'),
      sortByKey: ref('ui.state.portfolio.selectedKey'),
    }))
    .match('portfolio.chartAssets[{integers:index}].*', sortable({
      fromList: 'portfolio.assets',
      toList: 'portfolio.chartAssets',
      listLength: ref('portfolio.assets.length'),
      sortByKey: 'category.priority',
    }))
    .path('portfolio.assets.length', ({ res }) => res.redirect('roster.portfolio.assets.length'))
    .match('portfolio.assets[{integers:assetIndex}].category.id',
      (requests, { watchValues }) =>
        watchValues(requests.map(({ req }) =>
          `roster.portfolio.assets[${[req.params.assetIndex]}].class`))
          .map(classes =>
            requests.map(({ res }, index) =>
              res.value(classes[requests[index].req.params.assetIndex])))
    )
    .match('portfolio.assets[{integers:assetIndex}].category.name',
      (requests, { watchValues }) =>
        watchValues(requests.map(({ req }) =>
          `roster.portfolio.assets[${[req.params.assetIndex]}].name`))
          .map(classes =>
            requests.map(({ res }, index) =>
              res.value(classes[requests[index].req.params.assetIndex])))
    )
    .match('portfolio.assets[{integers:assetIndex}].category.priority',
      (requests, { get }) =>
        get(requests.map(({ req }) =>
          `roster.portfolio.assets[${[req.params.assetIndex]}].class`))
          .map(pathValues =>
            pathValues.map(({ path, value }) => ({
              path: `portfolio.assets[${getAssetIndex(path)}].category.priority`,
              value: value === 'loans' ? 1 : 2,
            })))
    )
    .match('portfolio.assets[{integers:assetIndex}].allocation.value', map(({ req, res }) =>
      res.redirect(`roster.portfolio.assets[${[req.params.assetIndex]}].allocation`)
    ))
    .match('portfolio.assets[{integers:assetIndex}].marketValue.value', map(({ req, res }) =>
      res.redirect(`roster.portfolio.assets[${[req.params.assetIndex]}].marketValue.value`)
    ))
    .match('portfolio.assetsByKey[{keys:asset}].*',
      (requests, { watchValues }) =>
        watchValues('portfolio.assets.length')
          .switchMap(([length]) => {
            if (length < 1) return Observable.of([]);

            return watchValues(`roster.portfolio.assets[0..${length - 1}].class`)
              .map((assetValues) =>
                requests.map(({ req, res }) => {
                  const index = assetValues.findIndex((asset) => asset === req.params.asset);
                  return res.redirect(`portfolio.assets[${index}].${req.params['*']}`);
                })
              );
          })
    )
    .match('portfolio.assets[{integers:assetIndex}].dayChange[{keys:key}]', map(({ req, res }) =>
      res.redirect(
        `roster.portfolio.assets[${[req.params.assetIndex]}].dayChange.${[req.params.key]}`)
    ))
    .path('portfolio.selectedChartAsset.category',
      ({ res }, { get, watchValues }) => {
        const selectedAssetIdPath = 'ui.chartAssets.selectedId';
        return watchValues(selectedAssetIdPath)
          .switchMap(([selectedAssetId]) =>
            (typeof selectedAssetId === 'number' ?
                get(`portfolio.chartAssets[${selectedAssetId}].category`)
                  .map(([rawPathValue]) => res.value(rawPathValue.value)) :
                Observable.of(res.value(undefined))
            ));
      }
    )
    .match('portfolio.selectedChartAsset[{keys:key}][{keys:childKey}]',
      (requests, { get, watchValues }) => {
        const selectedAssetIdPath = 'ui.chartAssets.selectedId';
        return watchValues([selectedAssetIdPath])
          .switchMap(([selectedAssetId]) => {
            const dereferencedPaths = requests.map(({ req }) => {
              const { key, childKey } = req.params;
              return `portfolio.chartAssets[${selectedAssetId}].${key}.${childKey}`;
            });
            return (typeof selectedAssetId === 'number' ?
                get(dereferencedPaths)
                  .map((rawPathValues) => rawPathValues.map(
                    ({ path, value }) => ({
                      path: `portfolio.selectedChartAsset.${split(path).slice(3).join('.')}`,
                      value,
                    }))) :
                Observable.of(
                  requests.map(({ res }) => res.value(undefined))
                )
            );
          });
      }
    )
    // .path('portfolio.assetNames', ({ res }) =>
    //   res.redirect('roster.portfolio.assetNames')
    // )
    .path('portfolio.assetNames', variable())


    .path('portfolio.performanceChart.length', ref('roster.portfolio.performanceChart.length'))
    .match('portfolio.performanceChart[{integers:index}][{keys:key}]', map(({ req, res }) =>{
       return res.redirect(`roster.portfolio.performanceChart[${req.params.index}].${req.params.key}`)
  }
    ))
    
    .path('portfolio.performanceLineChart.length', ref('roster.portfolio.performanceLineChart.length'))
    .match('portfolio.performanceLineChart[{integers:index}][{keys:key}]', map(({ req, res }) =>{
       return res.redirect(`roster.portfolio.performanceLineChart[${req.params.index}].${req.params.key}`)
    }
    ))
    .path('portfolio.busymode', variable(true))
    .path('portfolio.assetClassName', variable())
    .path('portfolio.AssetPositionClassName', variable())
    .path('portfolio.portfolioBarDismissed', variable(false))
    .path('portfolio.collateralSurplus', ({ res }) => res.redirect('roster.portfolio.collateralSurplus'))
    .path('portfolio.currencyExposure', variable())
    // .path('portfolio.currencyExposure', ({ res }) => {
    //   let ran_str = "random" + Math.round(Math.random() * 100);
    //   return res.redirect(`roster.portfolio.currencyExposure.${ran_str}`)
    // });
    .path('portfolio.portfoliosYTDData', ({ res }) => {
      let ran_str = "random" + Math.round(Math.random() * 100);
      return res.redirect(`roster.portfolio.portfoliosYTDData.${ran_str}`)
    });

